<div
  class="d-flex flex-stack flex-wrap pt-5 justify-content-center justify-content-xl-between bg-white"
>
  <div class="fs-6 fw-semibold text-gray-500 mb-0 mb-xl-0">
    {{
      "TABLE.PAGINATION_LIMIT_SHOWING"
        | translate
          : {
              start_value: ((sources.offset ? sources.offset : 0) + 1 | number),
              end_value:
                (sources.offset ? sources.offset : 0) +
                  (sources.limit ? sources.limit : sources.total) | number,
              total_value: sources.total | number
            }
    }}
  </div>

  <ul class="pagination">
    <li
      class="page-item previous"
      role="button"
      tabindex="0"
      (click)="changePage(sources.page - 1)"
      (keydown.enter)="changePage(sources.page - 1)"
      (keydown.space)="changePage(sources.page - 1); $event.preventDefault()"
      [ngClass]="sources.page === 1 || loading() ? 'disabled' : ''"
    >
      <a class="page-link cursor-pointer">
        <i class="previous"></i>
      </a>
    </li>

    @for (item of total_page; track $index; let i = $index) { @if(i+1 <=
    max_page && i+1 >= min_page){
    <li
      class="page-item"
      role="button"
      tabindex="0"
      [ngClass]="{ active: sources.page === i + 1 }"
      (click)="changePage(i + 1)"
      (keydown.enter)="changePage(i + 1)"
      (keydown.space)="changePage(i + 1); $event.preventDefault()"
      [ngClass]="[
        loading() ? 'disabled' : '',
        sources.page === i + 1 ? 'active ' : ''
      ]"
    >
      <a
        class="page-link cursor-pointer"
        [ngClass]="[sources.page === i + 1 ? 'bg-primary ' : '']"
      >
        {{ i + 1 }}
      </a>
    </li>
    }@else if (i+1 === max_page + 1) {
    <div class="d-flex align-items-center fw-bold text-muted me-2">...</div>
    }@else {
    <!-- <li
      class="page-item active"
      [ngClass]="{ active: sources.page === i + 1 }"
      (click)="pageChange(1)"
    >
      <a class="page-link cursor-pointer bg-primary text-white">
        {{ 1 }}
      </a>
    </li> -->
    } }
    <li
      class="page-item next"
      role="button"
      tabindex="0"
      (click)="changePage(sources.page + 1)"
      (keydown.enter)="changePage(sources.page + 1)"
      (keydown.space)="changePage(sources.page + 1); $event.preventDefault()"
      [ngClass]="
        sources.page === sources.total_page || loading() ? 'disabled' : ''
      "
    >
      <a class="page-link cursor-pointer">
        <i class="next"></i>
      </a>
    </li>
  </ul>
</div>
